import {DeletePopup} from "components/Admin/Pages/DeletePopup/DeletePopup";
import {collectionService} from "../../../services/collectionService";

export const CollectionDelete = () => {
  return (
    <DeletePopup
      queryKey="collections"
      deleteQuery={collectionService.delete}
      onSuccessNavigate="/users"
    />
  );
};
